export const LAYER_TYPE_FILL = 'fill';
export const LAYER_TYPE_LINE = 'line';
export const LAYER_TYPE_CIRCLE = 'circle';
